// extracted by mini-css-extract-plugin
export var blink = "_6b-2";
export var cursor = "_6b-1";
export var reactMarkdown = "_6b-3";
export var streamingText = "_6b-0";